export const REGISTRATION_RESPONSE = "REGISTRATION_RESPONSE";
export function registrationResponse(response) {
    return {
        type: REGISTRATION_RESPONSE,
        response: response,
    };
}
